import React from "react";

export const LogOut = () => <div>empty</div>;
